import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MapGeoJSONFeature } from "maplibre-gl";
import { useSelector } from "react-redux";
import { RootState } from "../store";

type HoveredCampgroundState = {
  hoveredCampground?: MapGeoJSONFeature;
};

const initialState: HoveredCampgroundState = {
  hoveredCampground: undefined,
};

const hoveredCampground = createSlice({
  name: "campgroundSearch",
  initialState,
  reducers: {
    setHoveredCampground: (
      state,
      action: PayloadAction<MapGeoJSONFeature | undefined>
    ) => {
      // If both are undefined or null, return
      if (!state.hoveredCampground && !action.payload) return;

      // If one is undefined/null and the other isn't, update
      if (!state.hoveredCampground || !action.payload) {
        // @ts-ignore
        state.hoveredCampground = action.payload;
        return;
      }

      // Compare relevant properties
      if (
        state.hoveredCampground.id === action.payload.id &&
        JSON.stringify(state.hoveredCampground.properties) ===
          JSON.stringify(action.payload.properties)
      ) {
        return;
      }

      state.hoveredCampground = action.payload;
    },
  },
});

export const { setHoveredCampground } = hoveredCampground.actions;

export default hoveredCampground.reducer;

// Simple selector - no transformation needed
const selectHoveredCampground = (state: RootState) =>
  state.hoveredCampground.hoveredCampground;

export const useHoveredCampground = () => {
  return useSelector(selectHoveredCampground);
};
